<div class="formulario-container">  
  <div *ngIf="cursoSeleccionado && cursoPreseleccionado" class="banner-preseleccion">
    <div class="banner-content">
      <span class="banner-label">Inscribiéndote en</span>
      <span class="banner-nombre">{{ cursoSeleccionado.nombre_curso }}</span>
    </div>
    <button class="banner-close" (click)="verTodosLosCursos()" title="Ver todos los cursos">&#x2715;</button>
  </div>
  <div class="title-container">
    <h1 class="formulario-titulo">Complete el formulario para la inscripción</h1>
  </div>
  <form [formGroup]="formularioInscripcion">
    <div class="form-body">
      <div class="form-row">
        <div class="form-group">
          <label for="rut">RUT:</label>
          <input type="text" id="rut" formControlName="rut" class="form-control" 
                 (input)="formatearRUT($event)" 
                 placeholder="Ej: 12345678-9"
                 maxlength="12">
          <div *ngIf="formularioInscripcion.get('rut')?.touched && formularioInscripcion.get('rut')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('rut')?.errors?.['required']">El RUT es obligatorio.</small>
            <small class="text-danger" *ngIf="formularioInscripcion.get('rut')?.errors?.['rutInvalido']">El RUT no es válido.</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="nombres">Nombres:</label>
          <input type="text" id="nombres" formControlName="nombres" class="form-control">
          <div *ngIf="formularioInscripcion.get('nombres')?.touched && formularioInscripcion.get('nombres')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('nombres')?.errors?.['required']">Los nombres son obligatorios.</small>
            <small class="text-danger" *ngIf="formularioInscripcion.get('nombres')?.errors?.['minlength']">Los nombres deben tener al menos 2 caracteres.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="apellidos">Apellidos:</label>
          <input type="text" id="apellidos" formControlName="apellidos" class="form-control">
          <div *ngIf="formularioInscripcion.get('apellidos')?.touched && formularioInscripcion.get('apellidos')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('apellidos')?.errors?.['required']">Los apellidos son obligatorios.</small>
            <small class="text-danger" *ngIf="formularioInscripcion.get('apellidos')?.errors?.['minlength']">Los apellidos deben tener al menos 2 caracteres.</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" id="email" formControlName="email" class="form-control">
          <div *ngIf="formularioInscripcion.get('email')?.touched && formularioInscripcion.get('email')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('email')?.errors?.['required']">El email es obligatorio.</small>
            <small class="text-danger" *ngIf="formularioInscripcion.get('email')?.errors?.['email']">El formato de email no es válido.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="telefono">Teléfono:</label>
          <input type="text" id="telefono" formControlName="telefono" class="form-control">
          <div *ngIf="formularioInscripcion.get('telefono')?.touched && formularioInscripcion.get('telefono')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('telefono')?.errors?.['required']">El teléfono es obligatorio.</small>
            <small class="text-danger" *ngIf="formularioInscripcion.get('telefono')?.errors?.['pattern']">El formato del teléfono no es válido (debe tener 9 dígitos).</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="direccion">Dirección:</label>
          <input type="text" id="direccion" formControlName="direccion" class="form-control">
          <div *ngIf="formularioInscripcion.get('direccion')?.touched && formularioInscripcion.get('direccion')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('direccion')?.errors?.['required']">La dirección es obligatoria.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="fechaNacimiento">Fecha de Nacimiento:</label>
          <input type="date" id="fechaNacimiento" formControlName="fechaNacimiento" class="form-control">
          <div *ngIf="formularioInscripcion.get('fechaNacimiento')?.touched && formularioInscripcion.get('fechaNacimiento')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('fechaNacimiento')?.errors?.['required']">La fecha de nacimiento es obligatoria.</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="ciudad">Ciudad:</label>
          <input type="text" id="ciudad" formControlName="ciudad" class="form-control">
          <div *ngIf="formularioInscripcion.get('ciudad')?.touched && formularioInscripcion.get('ciudad')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('ciudad')?.errors?.['required']">La ciudad es obligatoria.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="pais">País:</label>
          <input type="text" id="pais" formControlName="pais" class="form-control">
          <div *ngIf="formularioInscripcion.get('pais')?.touched && formularioInscripcion.get('pais')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('pais')?.errors?.['required']">El país es obligatorio.</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="profesion">Profesión:</label>
          <input type="text" id="profesion" formControlName="profesion" class="form-control">
          <div *ngIf="formularioInscripcion.get('profesion')?.touched && formularioInscripcion.get('profesion')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('profesion')?.errors?.['required']">La profesión es obligatoria.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label for="institucion">Institución:</label>
          <input type="text" id="institucion" formControlName="institucion" class="form-control">
          <div *ngIf="formularioInscripcion.get('institucion')?.touched && formularioInscripcion.get('institucion')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('institucion')?.errors?.['required']">La institución es obligatoria.</small>
          </div>
        </div>
  
        <div class="form-group">
          <label for="lugarTrabajo">Lugar de Trabajo:</label>
          <input type="text" id="lugarTrabajo" formControlName="lugarTrabajo" class="form-control">
          <div *ngIf="formularioInscripcion.get('lugarTrabajo')?.touched && formularioInscripcion.get('lugarTrabajo')?.invalid">
            <small class="text-danger" *ngIf="formularioInscripcion.get('lugarTrabajo')?.errors?.['required']">El lugar de trabajo es obligatorio.</small>
          </div>
        </div>
      </div>
  
      <div class="form-row">
        <div class="form-group">
          <label>Nacionalidad:</label>
          <div class="btn-group" role="group">
            <button type="button" class="btn" [class.active]="nacionalidadActiva === 'Chilena'" (click)="setNacionalidad('Chilena')">Chilena</button>
            <button type="button" class="btn" [class.active]="nacionalidadActiva === 'Extranjera'" (click)="setNacionalidad('Extranjera')">Extranjera</button>
          </div>
        </div>
  
        <div class="form-group">
          <label>Sexo:</label>
          <div class="btn-group" role="group">
            <button type="button" class="btn" [class.active]="sexoActivo === 'Masculino'" (click)="setSexo('Masculino')">Masculino</button>
            <button type="button" class="btn" [class.active]="sexoActivo === 'Femenino'" (click)="setSexo('Femenino')">Femenino</button>
          </div>
        </div>
      </div>
    </div>

    <div class="terminos-condiciones">
      <div class="container-terminos">
        <input type="checkbox" id="terminos" formControlName="terminos">
        <label for="terminos">Estoy de acuerdo con los términos y condiciones</label>
      </div>
      <div class="container-info">
        <p class="info-terminos">1. Una vez hecha y pagada la inscripción no habrá devolución del dinero así el participante no pueda realizarlo.</p>
        <p class="info-terminos">2. La reserva del cupo se efectúa luego de la transacción del pago.</p>
        <div *ngIf="formularioInscripcion.get('terminos')?.touched && formularioInscripcion.get('terminos')?.invalid">
          <small class="text-danger">Debe aceptar los términos y condiciones para continuar.</small>
        </div>
      </div>
    </div>
  </form>

  <div class="content-container">
    <div class="buscar-container" *ngIf="!cursoPreseleccionado">
      <div class="buscar-grupo">
        <label for="buscarCurso" class="buscar-label">Buscar curso:</label>
        <div class="resultados-info">
          <small>{{ cursosFiltrados.length === 0 ? '0 cursos encontrados' : (cursosFiltrados.length === 1 ? '1 curso encontrado' : cursosFiltrados.length + ' cursos encontrados') }}</small>
        </div>
        <input 
          type="text" 
          id="buscarCurso" 
          class="buscar-input" 
          placeholder="Ingrese el nombre del curso..." 
          [(ngModel)]="terminoBusqueda"
          (input)="filtrarCursos()">
        <div class="buscar-icon">
          🔍
        </div>
      </div>
    </div>
    <table class="styled-table">
      <thead>
        <tr>
          <th>Seleccione</th>
          <th>Nombre</th>
          <th>Descripción</th>
          <th>Vigencia</th>
          <th>Valor</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="cursosFiltrados.length === 0">
          <td colspan="6" style="text-align: center;">
            <div class="no-cursos-message">
              <p *ngIf="terminoBusqueda">No se encontraron cursos que coincidan con "{{ terminoBusqueda }}"</p>
              <p *ngIf="!terminoBusqueda">No hay cursos vigentes disponibles en este momento.</p>
              <small>Los cursos mostrados están vencidos o no se encuentran disponibles.</small>
            </div>
          </td>
        </tr>
        <tr *ngFor="let curso of cursosFiltrados">          
          <td><input type="radio" name="cursoSeleccionado" [value]="curso.id_curso" [checked]="cursoSeleccionado?.id_curso === curso.id_curso" (change)="onCursoSeleccionado($event, curso)"></td>
          <td>{{ curso.nombre_curso }}</td>
          <td>{{ curso.descripcion_curso }}</td>
          <td>{{ convertirFechaFormato(curso.fecha_inicio_vigencia) }} a {{ convertirFechaFormato(curso.fecha_fin_vigencia) }}</td>
          <td>{{ formatearValorCurso(curso.valor_curso) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="submit-container">
    <button type="button" class="btn-enviar" (click)="onContinuar()">Continuar</button>
  </div>
</div>